import React, { forwardRef } from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			height: "60px",
			userSelect: "none",
			"font-size": "16px",
			"line-height": "0.6",
			"border-radius": "10px",
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
			"font-family": "MuseoSansCyrl-700",
			"letter-spacing": "2.3px",
			color: theme.palette.colors.lightGrayishViolet,
			"text-transform": "uppercase",
			cursor: "pointer",
			display: "inline-flex",
			"justify-content": "center",
			"align-items": "center",
			"background-color": theme.palette.colors.white,
			"&$circle36": {
				padding: "0",
			},
		},
		purpleButton: {
			"background-color": theme.palette.colors.purplishBlue,
			color: theme.palette.colors.white,
			border: "none",
			"&:hover": {
				color: theme.palette.colors.white,
			},
		},
		fullWidth: {
			width: "100%",
		},
		circle36: {
			"border-radius": "50%",
			width: `36px`,
			height: `36px`,
		},
		grayBorder: {
			border: `0.5px solid  #DCE0E9`,
			boxShadow: `0px 0px 0.5px 0px rgba(17, 24, 36, 0.05),
			0px 0.75px 0.5px 0px rgba(17, 24, 36, 0.04),
			0px 1.5px 0.5px 0px rgba(17, 24, 36, 0.03),
			0px 2px 1px 0px rgba(17, 24, 36, 0.02),
			0px 3px 1px 0px rgba(17, 24, 36, 0.01)`,
			flexShrink: 0,
		},
		secondaryButton: {
			borderRadius: "128px",
			height: "36px",
			textTransform: "none",
			letterSpacing: 0,
		},
		connectButton: {
			"& a": {
				height: "100%",
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				color: theme.palette.colors.white,
				textAlign: "center",
			},
			"& a > div": {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
	};
};

const Button = forwardRef((props) => {
	const onClickHandler = (e) => {
		props.onClick?.(e);
	};

	const className = classNames(props.classes.root, {
		[props.classes.circle36]: props.circle36,
		[props.classes.grayBorder]: props.grayBorder,
		[props.classes.purpleButton]: props.status === "purple",
		[props.classes.secondaryButton]: props.secondaryButton,
		[props.classes.fullWidth]: props.fullWidth,
		[props.classes.connectButton]: props.connectButton,
	});

	if (props.component && !props.stub) {
		return React.cloneElement(props.component, {
			onClick: (e) => onClickHandler(e),
			className: className,
			children: props.children,
			datatest: props.datatest,
		});
	}

	return (
		<button
			style={props.style}
			ref={props.buttonRef}
			onClick={onClickHandler}
			className={className}
			data-test={props.datatest}
		>
			{!props.stub && props.children}
		</button>
	);
});

Button.defaultProps = {
	datatest: null,
	onClick: () => {},
	circle: false,
};

const styledButton = withStyles(styles)(Button);
styledButton.displayName = "Button";

export default styledButton;
